export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">焦点专题</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20event%20with%20warm%20spotlight%2C%20celebrity%20silhouette%20surrounded%20by%20paparazzi%20camera%20flashes%2C%20entertainment%20scandal%20theme%2C%20cinematic%20night%20scene%2C%20high%20contrast%20dramatic%20lighting&width=600&height=400&seq=carousel-01&orientation=landscape"
                alt="2026上半年娱乐圈大事件回顾"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-primary-100 text-primary-700 px-2 py-0.5 rounded whitespace-nowrap">重磅专题</span>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mt-2 group-hover:text-primary-500 transition-colors line-clamp-2">2026上半年娱乐圈大事件回顾</h3>
              <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">从明星塌房到综艺丑闻，半年来最令人震惊的十大娱乐事件</p>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20trending%20hashtags%20with%20warm%20red%20glow%2C%20influencer%20scandal%20theme%2C%20dark%20ambient%20lighting%2C%20multiple%20floating%20notification%20bubbles%2C%20digital%20age%20gossip%20aesthetic&width=600&height=400&seq=carousel-02&orientation=landscape"
                alt="网红经济：从顶流到塌房的距离"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-accent-100 text-accent-800 px-2 py-0.5 rounded whitespace-nowrap">深度专题</span>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mt-2 group-hover:text-primary-500 transition-colors line-clamp-2">网红经济：从顶流到塌房的距离</h3>
              <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">分析近年来的网红翻车案例，揭示流量背后的泡沫</p>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Production%20studio%20behind%20the%20scenes%20with%20dramatic%20warm%20lighting%2C%20camera%20equipment%20and%20scripts%20on%20table%2C%20reality%20TV%20production%20theme%2C%20mysterious%20atmosphere%2C%20amber%20and%20crimson%20color%20palette&width=600&height=400&seq=carousel-03&orientation=landscape"
                alt="综艺节目制作内幕大起底"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-secondary-200 text-secondary-800 px-2 py-0.5 rounded whitespace-nowrap">独家专题</span>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mt-2 group-hover:text-primary-500 transition-colors line-clamp-2">综艺节目制作内幕大起底</h3>
              <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">前综艺导演匿名分享真人秀不为人知的剧本操作</p>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Film%20industry%20award%20ceremony%20stage%20with%20dramatic%20golden%20and%20amber%20lights%2C%20empty%20trophy%20on%20pedestal%2C%20casting%20controversy%20theme%2C%20dark%20elegant%20background%2C%20cinematic%20atmosphere%20with%20soft%20glow&width=600&height=400&seq=carousel-04&orientation=landscape"
                alt="影视圈选角潜规则深度报告"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-primary-100 text-primary-700 px-2 py-0.5 rounded whitespace-nowrap">调查专题</span>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mt-2 group-hover:text-primary-500 transition-colors line-clamp-2">影视圈选角潜规则深度报告</h3>
              <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">从投资方到导演，选角链条中的利益输送全解析</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}